import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( '@/views/HomeView.vue')
  },
  {
    path: '/openCostType',
    name: 'openCostType',
    component: () => import( '@/views/openCostType.vue')
  },
  {
    path: '/openInvoiceType',
    name: 'openInvoiceType',
    component: () => import( '@/views/openInvoiceType.vue')
  },
  {
    path: '/contractorAndStaffType',
    name: 'contractorAndStaffType',
    component: () => import( '@/views/contractorAndStaffType.vue')
  },
  {
    path: '/payWaysType',
    name: 'payWaysType',
    component: () => import( '@/views/payWaysType.vue')
  },
  {
    path: '/departmentType',
    name: 'departmentType',
    component: () => import( '@/views/departmentType.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
